// extracted by mini-css-extract-plugin
export default {"socials":"socials_socials__gP4Mc","iconWrapper":"socials_iconWrapper__Hqc2R"};